import { LoginView } from "../../pages/Registry"
import { IGameCopper, IGameResult, TopicI18nStore } from ".."
import copper from "./json/copper.json"
import result from "./json/result.json"

export const TOPIC_STORE: TopicI18nStore = {
    objects: {
        gameCopper: copper as Record<string, IGameCopper>,
        gameResult: result as Record<string, IGameResult>,
        relicDict: {},
        relicGroups: [],
        gameRandomDict: {
            band: [],
            recruitGroups: [],
            relics: [],
        },
    },
    LoginView,
}
